import { constantRouterMap } from '@/router'
import adminRouter from '../../router/modules/adminRouter'
import systemRouter from '../../router/modules/systemRouter'
import opreateRouter from '../../router/modules/operateRouter'
import { getUserName } from '../../utils/auth'

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.role) {
    return roles.some(role => route.meta.role.indexOf(role) >= 0)
  } else {
    return true
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncRouterMap, roles) {
  // console.log("accessedRouters="+asyncRouterMap);
  const accessedRouters = asyncRouterMap.filter(route => {
    if (hasPermission(roles, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    }
  },
  actions: {
    GenerateRoutes({ commit }) {
      return new Promise(resolve => {
        // const roles = data
        let accessedRouters
        if (getUserName().indexOf('root') >= 0) {
        // console.log('admin>=0')
          accessedRouters = systemRouter
        } else if (getUserName().indexOf('admin') >= 0) {
        // console.log('admin>=0')
          accessedRouters = adminRouter
        } else if (getUserName().indexOf('opreate') >= 0) {
          accessedRouters = opreateRouter
        } else {
          accessedRouters = opreateRouter
        }
        console.log('accessedRouters', accessedRouters)
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js